import { FunctionalClaim, IUserInfo } from 'gen/ApiClient';

export function calculateUserHasFunctionalClaim(user: IUserInfo, functionalClaim: FunctionalClaim): boolean {
	if (user.functionalClaims === undefined || user.functionalClaims === null || user.functionalClaims.length === 0) {
		return false;
	} else {
		return user.functionalClaims.indexOf(functionalClaim as FunctionalClaim) > -1;
	}
}
